//
// Module for the Retirement Setup wizard's Eligibility step
//
rs.module("participant/benefit/setup/retirement/wizard/eligibilitystep",

    ["controls/components/event-banner"],

    function (eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, variables, backendUrls) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var benefitTypeSelect = stepContainer.js(jsSelectors.benefitTypeSelect);
            var loadingSpinner = stepContainer.js(jsSelectors.loadingSpinner);
            var stepDetailContainer = stepContainer.js(jsSelectors.stepDetailContainer);

            // Hookup benefitTypeSelect change event
            benefitTypeSelect.change(benefitTypeChange);

            // Benefit Type change event
            function benefitTypeChange() {

                loadingSpinner.show();

                // Get selected Benefit Type
                var selectedBenefitType = benefitTypeSelect.val();

                // clear any messages in the message banner
                eventBanner.removeAllMessages();

                // Replace step detail content
                $.get(backendUrls.getEligibilityStepDetail,
                    {
                        benefitClaimPaymentKey: variables.benefitClaimPaymentKey,
                        benefitType: selectedBenefitType,
                        isRecalc: variables.isRecalc
                    })
                    .done(function (html) {
                        stepDetailContainer.html(html);
                    })
                    .always(function () {
                        loadingSpinner.hide();
                    });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);